<template>
  <div class="service" :class="{right:value1==true || value2==true}">
    <ul class="list">
      <li class="img1" @click="value1=true"></li>
      <li class="img2" @click="value2=true"></li>
      <li class="img3" @click="go()"></li>
    </ul>
    <Drawer :closable="false" v-model="value1" width="400" :scrollable="true" class="drawer">
      <Calculator></Calculator>
    </Drawer>
    <Drawer :closable="false" v-model="value2" width="400" :scrollable="true" class="drawer">
      <Worker></Worker>
    </Drawer>
  </div>
</template>

<script>
import Calculator from "./modal/calculator";
import Worker from "./modal/worker";
export default {
  components: { Calculator ,Worker},
  data() {
    return {
      value1: false,
      value2: false
    };
  },
  methods:{
    go(){
      window.scrollTo(0,0)
    }
  }
};
</script>

<style lang="less" scoped>
.right {
  right: 405px !important;
  transition: all 0.35s;
}
.service {
  position: fixed;
  right: 25px;
  bottom: 20%;
  z-index: 99;
  transition: all 0.32s;
  .list {
    li {
      width: 60px;
      height: 60px;
      margin-bottom: 20px;
      background: url("../assets/sidebar_icons.png") no-repeat;
      background-size: cover;
      cursor: pointer;
    }
    .img1 {
      &:hover {
        background-position: 0 -180px;
      }
    }
    .img2 {
      background-position: 0 -60px;
      &:hover {
        background-position: 0 -240px;
      }
    }
    .img3 {
      background-position: 0 -120px;
      &:hover {
        background-position: 0 -300px;
      }
    }
  }
}
/deep/.ivu-drawer-body {
  padding: 0 !important;
}
</style>

